"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateQuestions = exports.transformDefaultMetadata = exports.isBudgetQuestion = exports.hasHandsetFlow = exports.getProgressPercentage = exports.filterBrandQuestionChoices = exports.createStateMetadata = void 0;
var _constants = require("./constants");
var _services = require("../services");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var market;
var isBudgetQuestion = function isBudgetQuestion(question) {
  return (question === null || question === void 0 ? void 0 : question.id) === _constants.QUESTION_ID.BUDGET;
};
exports.isBudgetQuestion = isBudgetQuestion;
var createStateMetadata = function createStateMetadata(metadata, categoryPriceTypes) {
  console.log('-- metadata', metadata);
  var stateMetadata = {
    recommendationCategories: []
  };
  Object.entries(metadata).forEach(function (_ref) {
    var _categoryPriceTypes$f;
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (key === 'flags') return;
    var priceType = (_categoryPriceTypes$f = categoryPriceTypes.find(function (category) {
      return category.category === key;
    })) === null || _categoryPriceTypes$f === void 0 ? void 0 : _categoryPriceTypes$f.priceType;
    stateMetadata.recommendationCategories.push(_objectSpread({
      category: key,
      priceType: priceType
    }, value));
  });
  console.log('-- stateMetadata', stateMetadata);
  return stateMetadata;
};
exports.createStateMetadata = createStateMetadata;
var filterBrandQuestionChoices = function filterBrandQuestionChoices(questions, brandNameList) {
  var brandQuestion = questions.find(function (question) {
    return question.id === _constants.QUESTION_ID.BRANDS;
  });
  if (brandQuestion) {
    brandQuestion.choices = brandQuestion.choices.filter(function (choice) {
      return choice.catalogName ? brandNameList.includes(choice.catalogName.toLowerCase()) : true;
    });
  }
};
exports.filterBrandQuestionChoices = filterBrandQuestionChoices;
var transformDefaultMetadata = function transformDefaultMetadata(defaultMetadata) {
  var _defaultMetadata$reco;
  var metadata = {};
  (_defaultMetadata$reco = defaultMetadata.recommendationCategories) === null || _defaultMetadata$reco === void 0 ? void 0 : _defaultMetadata$reco.forEach(function (recommendationCategory) {
    Object.keys(recommendationCategory).filter(function (characteristic) {
      return !['category', 'priceType'].includes(characteristic);
    }).forEach(function (characteristic) {
      var _defaultMetadata$reco2;
      metadata[recommendationCategory.category] = _objectSpread(_objectSpread({}, metadata[recommendationCategory.category]), {}, _defineProperty({}, characteristic, (_defaultMetadata$reco2 = defaultMetadata.recommendationCategories) === null || _defaultMetadata$reco2 === void 0 ? void 0 : _defaultMetadata$reco2.find(function (_ref3) {
        var category = _ref3.category;
        return category === (recommendationCategory === null || recommendationCategory === void 0 ? void 0 : recommendationCategory.category);
      })[characteristic]));
    });
  });
  return metadata;
};
exports.transformDefaultMetadata = transformDefaultMetadata;
var translateCommonQuestionFields = function translateCommonQuestionFields(question) {
  return _objectSpread(_objectSpread({}, question), {}, {
    title: _services.locale.localeString("Questions.".concat(market, ".").concat(question.title), {
      defaultValue: question.title,
      skipInterpolation: true
    }),
    subtitle: question.subtitle ? _services.locale.localeString("Questions.".concat(market, ".").concat(question.subtitle), {
      defaultValue: question.subtitle,
      skipInterpolation: true
    }) : undefined,
    summary: question.summary ? _services.locale.localeString("Questions.".concat(market, ".").concat(question.summary), {
      defaultValue: question.summary,
      skipInterpolation: true
    }) : undefined
  });
};
var translateRangeChoices = function translateRangeChoices(rangeChoices) {
  var _rangeChoices$labels;
  return _objectSpread(_objectSpread({}, rangeChoices), {}, {
    minLabel: _services.locale.localeString("Questions.".concat(market, ".").concat(rangeChoices.minLabel), {
      defaultValue: rangeChoices.minLabel,
      skipInterpolation: true
    }),
    maxLabel: _services.locale.localeString("Questions.".concat(market, ".").concat(rangeChoices.maxLabel), {
      defaultValue: rangeChoices.maxLabel,
      skipInterpolation: true
    }),
    labels: (_rangeChoices$labels = rangeChoices.labels) === null || _rangeChoices$labels === void 0 ? void 0 : _rangeChoices$labels.map(function (label) {
      return _objectSpread(_objectSpread({}, label), {}, {
        label: _services.locale.localeString("Questions.".concat(market, ".").concat(label.label), {
          defaultValue: label.label,
          skipInterpolation: true
        })
      });
    })
  });
};
var translateQuestions = function translateQuestions(questions, selectedMarket) {
  market = _constants.MARKET_QUESTION_MAP[selectedMarket];
  var translatedQuestions = questions.map(function (nonTranslatedQuestion) {
    var question = translateCommonQuestionFields(nonTranslatedQuestion);
    switch (question.type) {
      case _constants.QUESTION_TYPE.CHOICES:
        {
          var translatedChoices = question.choices.map(function (choice) {
            return _objectSpread(_objectSpread({}, choice), {}, {
              text: _services.locale.localeString("Questions.".concat(market, ".").concat(choice.text), {
                defaultValue: choice.text,
                skipInterpolation: true
              }),
              summary: choice.summary ? _services.locale.localeString("Questions.".concat(market, ".").concat(choice.summary), {
                defaultValue: choice.summary,
                skipInterpolation: true
              }) : undefined,
              summaryText: choice.summaryText ? _services.locale.localeString("Questions.".concat(market, ".").concat(choice.summaryText), {
                defaultValue: choice.summaryText,
                skipInterpolation: true
              }) : undefined
            });
          });
          return _objectSpread(_objectSpread({}, question), {}, {
            choices: translatedChoices
          });
        }
      case _constants.QUESTION_TYPE.RANGE:
        {
          var translatedRangeChoices = translateRangeChoices(question.rangeChoices);
          return _objectSpread(_objectSpread({}, question), {}, {
            rangeTitle: _services.locale.localeString("Questions.".concat(market, ".").concat(question.rangeTitle), {
              defaultValue: question.rangeTitle,
              skipInterpolation: true
            }),
            rangeChoices: translatedRangeChoices
          });
        }
      case _constants.QUESTION_TYPE.MULTI:
        {
          var translatedMulti = question.multi.map(function (rangeSegment) {
            var translatedRangeChoices = translateRangeChoices(rangeSegment.rangeChoices);
            return _objectSpread(_objectSpread({}, rangeSegment), {}, {
              rangeChoices: translatedRangeChoices,
              rangeTitle: _services.locale.localeString("Questions.".concat(market, ".").concat(rangeSegment.rangeTitle), {
                defaultValue: rangeSegment.rangeTitle,
                skipInterpolation: true
              })
            });
          });
          return _objectSpread(_objectSpread({}, question), {}, {
            multi: translatedMulti
          });
        }
      case _constants.QUESTION_TYPE.SEARCH:
        return _objectSpread({}, question);
      case _constants.QUESTION_TYPE.IMAGE:
        {
          var _translatedChoices = question.choices.map(function (choice) {
            return _objectSpread(_objectSpread({}, choice), {}, {
              text: _services.locale.localeString("Questions.".concat(market, ".").concat(choice.text), {
                defaultValue: choice.text,
                skipInterpolation: true
              }),
              summary: choice.summary ? _services.locale.localeString("Questions.".concat(market, ".").concat(choice.summary), {
                defaultValue: choice.summary,
                skipInterpolation: true
              }) : undefined,
              summaryText: choice.summaryText ? _services.locale.localeString("Questions.".concat(market, ".").concat(choice.summaryText), {
                defaultValue: choice.summaryText,
                skipInterpolation: true
              }) : undefined
            });
          });
          return _objectSpread(_objectSpread({}, question), {}, {
            choices: _translatedChoices
          });
        }
      default:
        return question;
    }
  });
  return translatedQuestions;
};
exports.translateQuestions = translateQuestions;
var hasHandsetFlow = function hasHandsetFlow(questions) {
  return questions === null || questions === void 0 ? void 0 : questions.some(function (question) {
    var _question$choices;
    return question === null || question === void 0 ? void 0 : (_question$choices = question.choices) === null || _question$choices === void 0 ? void 0 : _question$choices.some(function (choice) {
      var _choice$enable;
      return choice === null || choice === void 0 ? void 0 : (_choice$enable = choice.enable) === null || _choice$enable === void 0 ? void 0 : _choice$enable.includes('phone');
    });
  });
};
exports.hasHandsetFlow = hasHandsetFlow;
var calculateMaxPathLength = function calculateMaxPathLength(questions, currentQuestion) {
  var maxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (currentQuestion !== null && currentQuestion !== void 0 && currentQuestion.choices) {
    var _iterator = _createForOfIteratorHelper(currentQuestion.choices),
      _step;
    try {
      var _loop = function _loop() {
        var choice = _step.value;
        var nextQuestion = questions.find(function (q) {
          var _choice$enable2;
          return choice === null || choice === void 0 ? void 0 : (_choice$enable2 = choice.enable) === null || _choice$enable2 === void 0 ? void 0 : _choice$enable2.includes(q.if);
        });
        if (nextQuestion) {
          var pathLength = calculateMaxPathLength(questions, nextQuestion) + 1;
          maxLength = Math.max(maxLength, pathLength);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return maxLength;
};
var getProgressPercentage = function getProgressPercentage(questions, currentQuestion, currentQuestionIndex) {
  if (!currentQuestion.if) {
    return (currentQuestionIndex + 1) / questions.length * 100;
  } else {
    var maxLength = calculateMaxPathLength(questions, currentQuestion);
    var allCasesQuestionsLength = questions.filter(function (q) {
      return !q.if;
    }).length;
    var questionsWithSameCondition = questions.filter(function (q) {
      return q.if === currentQuestion.if;
    });
    var newQuestionIndex;
    if (questionsWithSameCondition.length === 1) {
      newQuestionIndex = maxLength + 1;
    } else {
      newQuestionIndex = questionsWithSameCondition.findIndex(function (q) {
        return q.title === currentQuestion.title && q.type === currentQuestion.type && q.maxSelections === currentQuestion.maxSelections && JSON.stringify(q.choices) === JSON.stringify(currentQuestion.choices);
      });
    }
    var finalIndex = Math.min(newQuestionIndex, currentQuestionIndex);
    return (finalIndex + 1) / (maxLength + allCasesQuestionsLength + questionsWithSameCondition.length) * 100;
  }
};
exports.getProgressPercentage = getProgressPercentage;